import styled from 'styled-components';

export const Subtitle = styled.div`
  font-size: 16px;
  font-weight: 300;
  margin-top: 8px;
`;

export const Wrapper = styled.div`
  height: 45px;
`;
